import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { GlobalApiService } from '@core/http/global-api.service';
import { AuditSignIn } from '@core/models/admin-physician/audit-sign-in';
import { environment } from '@env/environment';
import {  Store } from '@ngxs/store';
import { AppConfigData } from 'app/app.config.data';
import { storeUserIdPhyIdState } from 'app/authentication/Store/auth.state';
import { storePatientIdVisitIdState } from 'app/er-dashboard/erdashboard-store/erdashboard.state';
import { Observable, Subject } from 'rxjs';
import { map, switchMap, takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuditLogService {
  _store=inject(Store)
  today_Date:Date = new Date()
  ipAddress: string;
  patientIdVisitId$: Observable<any>=this._store.select(storePatientIdVisitIdState.getPatientIdVisitId);
  userIdPatientId$: Observable<any>=this._store.select(storeUserIdPhyIdState.getUserIdPhyId)
  staffId: number;
  practiceId: number;
  physicianId: number;
  userId: number;
  userName: string;
  shortName: string;
  roleId: number;
  LocationId: number;
  patientId: number;
  visitId: number;
  onDestroy$ =new Subject()
  constructor(private apiService: GlobalApiService, private datePipe: DatePipe, private https: HttpClient,) {
   // this.getIPAddress() // Temp disabled to get IP Address after purchanging service then we will enable

    // this.locationdata();
    this.userIdPatientId$.pipe(takeUntil(this.onDestroy$)).subscribe(res => {
      // console.log("store value:", res)
      if (res) {
      this.staffId = res?.staffId;
      this.practiceId = res?.practiceId;
      // this.selectedLocationId = res?.locationId;
      this.physicianId = res?.physicianId;
      this.userId = +res?.userId;
      this.userName = res?.userName;
      // this.locationId=this.selectedLocationId;
      this.shortName = res?.shortName;
      this.roleId = res?.roleId;
      this.LocationId = res?.locationId;
      }
    })
    this.patientIdVisitId$.pipe(takeUntil(this.onDestroy$)).subscribe(res=>{
      // console.log("patientId1.......",res)
      if (res) {
      this.patientId=res?.patientId ??res?.patientModel?.patientId ;
      this.visitId=res?.visitId;
      // console.log(res?.patientModel)
      }
    })
  }
  //get System Id Address
  getIPAddress() {
    const httpHeaders = new HttpHeaders().set('Content-Type', 'application/json');
    httpHeaders.append('Access-Control-Allow-Origin','*')
    //this.https.get("https://api.ipify.org/?format=json", { observe: 'response', headers: httpHeaders}).subscribe((res: any) => {
    this.https.get("https://ipapi.co/json", { observe: 'response', headers: httpHeaders}).pipe(takeUntil(this.onDestroy$)).subscribe((res: any) => {
    //this.https.get("http://ip-api.com/json", { observe: 'response', headers: httpHeaders}).subscribe((res: any) => {
      this.ipAddress = res.ip;
      //this.ipAddress = res.query;
      // localStorage.setItem("ipAddress", res.ip)
      // localStorage.getItem("ipAddress")

      // console.log(this.ipAddress, "Ip Address")
    });
  }

  getClientIpAddress(): Observable<HttpResponse<any>>{
   return this.apiService.getDataDirectUrl('https://ipapi.co/json');//https://ipapi.co/json

  }
getIPAddressData(){
 return this.apiService.getIpAddressData()
}

  saveAudit(
    active_Id:number, description:string, moduleName:string,email:string,encryptType:string, patientId?: number, visitId?: number,physicianId?: number, practiceId?: number, staffId?: number ): Observable<HttpResponse<any>> {
    let auditObj = new AuditSignIn();
    auditObj.activity_Type = active_Id;
    auditObj.activity_Desc = description;
    auditObj.moduleName = moduleName;
    auditObj.physician_Id = physicianId ?? this.physicianId;
    auditObj.staffId = staffId ?? this.staffId;
    auditObj.patient_Id = patientId ?? this.patientId;
    auditObj.visitId = visitId ?? this.visitId;
    auditObj.practiceID = practiceId ?? this.practiceId;
    auditObj.patientLocation = "";  
    auditObj.reasonforUpdate = "";  
    auditObj.logOnOffUser = "";    
    auditObj.enteredBy = this.userId;
    auditObj.email=email;
    auditObj.encryptType=encryptType
    auditObj.activity_IdOut = 0;
    auditObj.UserId = this.shortName;
    auditObj.LoginTime = this.datePipe.transform(this.today_Date, environment.date_time_format);
   
    auditObj.LoginRemoteIP = "";
    auditObj.Status = "T";

    const formattedDate = this.datePipe.transform(this.today_Date, environment.date_time_format);
    auditObj.startDate = formattedDate;
    auditObj.endDate = formattedDate;
    auditObj.lonONOffDate = formattedDate;
  
    auditObj.logONOff = true;
    auditObj.activity_Id = 0;
    auditObj.topTable = 0;
    auditObj.effectedTableName = "";
    auditObj.effectedColumnName = "";
    auditObj.effectedTableID = "";
    auditObj.auditTableName = "";
    auditObj.auditColumnName = "";
    auditObj.auditTableID = "";
    auditObj.effectedQuery = "";
    auditObj.auditQuery = "";
    auditObj.publicIP = "";  
    auditObj.systemIP="";
    auditObj.LoginSystemIP="";
    // return this.getIPAddressData().pipe(map((response: HttpResponse<any>) => {
    //     auditObj.LoginSystemIP = response.body?.ip || '';
    //     auditObj.systemIP = response.body?.ip || '';
    //     return auditObj;
    //   }),
    //   switchMap((auditObj) => {
        const data1 = JSON.stringify(auditObj);
        return this.apiService.postData(environment.saveAuditData, data1);
      // })
    // );
  }
  saveAudit1(
    active_Id:number, description:string, moduleName:string,email:string,encryptType:string, patientId?: number, visitId?: number,physicianId?: number, practiceId?: number, staffId?: number ) {
    let auditObj = new AuditSignIn();
    auditObj.activity_Type = active_Id;
    auditObj.activity_Desc = description;
    auditObj.moduleName = moduleName;
    auditObj.physician_Id = physicianId ?? this.physicianId;
    auditObj.staffId = staffId ?? this.staffId;
    auditObj.patient_Id = patientId ?? this.patientId;
    auditObj.visitId = visitId ?? this.visitId;
    auditObj.practiceID = practiceId ?? this.practiceId;
    auditObj.patientLocation = "";  
    auditObj.reasonforUpdate = "";  
    auditObj.logOnOffUser = "";    
    auditObj.enteredBy = this.userId;
    auditObj.email=email;
    auditObj.encryptType=encryptType
    auditObj.activity_IdOut = 0;
    auditObj.UserId = this.shortName;
    auditObj.LoginTime = this.datePipe.transform(this.today_Date, environment.date_time_format);
   
    auditObj.LoginRemoteIP = "";
    auditObj.Status = "T";

    const formattedDate = this.datePipe.transform(this.today_Date, environment.date_time_format);
    auditObj.startDate = formattedDate;
    auditObj.endDate = formattedDate;
    auditObj.lonONOffDate = formattedDate;
  
    auditObj.logONOff = true;
    auditObj.activity_Id = 0;
    auditObj.topTable = 0;
    auditObj.effectedTableName = "";
    auditObj.effectedColumnName = "";
    auditObj.effectedTableID = "";
    auditObj.auditTableName = "";
    auditObj.auditColumnName = "";
    auditObj.auditTableID = "";
    auditObj.effectedQuery = "";
    auditObj.auditQuery = "";
    auditObj.publicIP = "";  
    auditObj.systemIP="";
    auditObj.LoginSystemIP="";
    // return this.getIPAddressData().pipe(map((response: HttpResponse<any>) => {
    //     auditObj.LoginSystemIP = response.body?.ip || '';
    //     auditObj.systemIP = response.body?.ip || '';
    //     return auditObj;
    //   }),
    //   switchMap((auditObj) => {
        const data1 = JSON.stringify(auditObj);
        const blob = new Blob(
          [JSON.stringify(data1)],
          { type: 'application/json' }
        );
    let logoutUrl= `${AppConfigData.apiBaseUrl}+/Audit/ActivityLog`
        navigator.sendBeacon(logoutUrl, blob);
        // return this.apiService.postData(environment.saveAuditData, data1);
      // })
    // );
  }
  updateAuditEndDate(activityId: number){
    return this.apiService.updateData(environment.saveAuditData+"?activityLogId="+activityId,'');
  }
  
  saveAdvancedirectives(active_Id, description, moduleName,patientId): Observable<HttpResponse<any>> {
    let auditObj = new AuditSignIn()
    auditObj.activity_Type = active_Id
    auditObj.startDate = this.datePipe.transform(this.today_Date, environment.date_time_format)
    auditObj.endDate = this.datePipe.transform(this.today_Date, environment.date_time_format)
    auditObj.lonONOffDate = this.datePipe.transform(this.today_Date, environment.date_time_format)
    auditObj.logONOff = true;
    auditObj.activity_Id = 0
    auditObj.activity_By = this.userId;
    auditObj.topTable = 0;
    auditObj.effectedTableName = "";
    auditObj.effectedColumnName = "";
    auditObj.effectedTableID = "";
    auditObj.auditTableName = "";
    auditObj.auditColumnName = "";
    auditObj.auditTableID = "";
    auditObj.activity_Desc = description;
    auditObj.effectedQuery = "";
    auditObj.auditQuery = "";
    auditObj.moduleName = moduleName;
    auditObj.physician_Id = this.physicianId;
    auditObj.staffId = this.staffId ??0;
    auditObj.patient_Id = patientId
    auditObj.visitId =this.visitId;
    auditObj.practiceID = this.practiceId;
    auditObj.patientLocation = "";
    // auditObj.systemIP="";
    auditObj.publicIP = "";
    auditObj.reasonforUpdate = "";
    auditObj.logOnOffUser = "";
    auditObj.enteredBy = this.userId;
    auditObj.activity_IdOut = 0
    // auditObj.LogId = 0;
    auditObj.UserId = this.shortName;
    auditObj.LoginTime = this.datePipe.transform(this.today_Date, environment.date_time_format);
    auditObj.LoginRemoteIP = "";
    auditObj.Status = "T";
    return this.getIPAddressData().pipe(map((response: HttpResponse<any>) => {
      auditObj.LoginSystemIP = response.body?.ip || '';
      auditObj.systemIP = response.body?.ip || '';
      return auditObj;
    }),
    switchMap((auditObj) => {
      const data1 = JSON.stringify(auditObj);
      return this.apiService.postData(environment.saveAuditData, data1);
    })
   );
  }
  activityLogOut(userId: number):Observable<HttpResponse<any>>{
    // console.log("log out service",this.apiService.getData(environment.activityLogOut+"?UserId="+userId));
    return this.apiService.getData(environment.activityLogOut+"?UserId="+userId);
  }
 
}
